<template>
  <div>
    <div class="title">{{ year }}年{{ yxmc }}毕业生信息</div>
    <div>
      <el-row>
        <!-- 一行中有两个大小相同的列 -->
        <el-col :span="12" class="col1">
          <div id="myChart5" :style="{ width: '100%', height: '100%' }"></div>
        </el-col>
        <el-col :span="12" class="col2">
          <div id="myChart6" :style="{ width: '100%', height: '100%' }"></div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>


<script>
import school from "../../api/forecast";
export default {
  data() {
    return {
      data: [],
      idzk: 18,
      yxmc: "湖北大学",
      year: 2020,
      zboys: 100,
      zgirls: 100,
      zsx: 0,
      zwjy: 0,
      zlhjy: 0,
      zcy: 0,
      zxyhhtjy: 0,
      //图一
      option5: {
        title: {
          text: "毕业生男女比例",
          // subtext: "Fake Data",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "北京大学",
            type: "pie",
            radius: "50%",
            data: [
              { value: 34, name: "男生人数", itemStyle: { color: "#00a8e1" } },
              { value: 66, name: "女生人数", itemStyle: { color: "#e30039" } },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },

      //图二

      option6: {
        title: {
          text: "毕业生就业去向",
          // subtext: "Fake Data",
          left: "center",
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          left: "left",
        },
        series: [
          {
            name: "北京大学",
            type: "pie",
            radius: "50%",
            data: [
              { value: 1048, name: "升学", itemStyle: { color: "#00a8e1 " } },
              { value: 735, name: "未就业", itemStyle: { color: "#99cc00  " } },
              {
                value: 580,
                name: "灵活就业",
                itemStyle: { color: "#e30039  " },
              },
              { value: 484, name: "创业", itemStyle: { color: "#fcd300  " } },
              {
                value: 300,
                name: "协议合同就业",
                itemStyle: { color: "#ff6600  " },
              },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  },
  props: ["idzk"],
  //监听
  watch: {
    option5: {
      handler(newName, oldName) {
        if (newName) {
          this.drawGender2();
        }
      },
      deep: true,
    },

    option6: {
      handler(newName, oldName) {
        if (newName) {
          this.drawEmployment2();
        }
      },
      deep: true,
    },

    idzk: {
      handler(newValue, oldValue) {
        if (newValue) {
          this._data.idzk = this._props.idxx;
          this.getJyxxSchoolById();
        }
      },
      deep: true,
    },
  },

  mounted() {
    // this.id = this.$route.query.id;
    this.getJyxxSchoolById();

    this.drawGender2();
    this.drawEmployment2();
  },

  created() {
    this.idzx = this._props.idzk;
  },

  methods: {
    getJyxxSchoolById() {
      school.getJyxxSchoolById(this.idzk).then((res) => {
        // console.log(res);
        this.data = res.data;
        this.yxmc = this.data.yxmc;
        this.year = this.data.year;
        this.option5.series[0].name = this.data.yxmc;
        this.option5.series[0].data[0].value = this.data.zboys;
        this.option5.series[0].data[1].value = this.data.zgirls;
        this.option6.series[0].name = this.data.yxmc;
        this.option6.series[0].data[0].value = this.data.zsx;
        this.option6.series[0].data[1].value = this.data.zwjy;
        this.option6.series[0].data[2].value = this.data.zlhjy;
        this.option6.series[0].data[3].value = this.data.zcy;
        this.option6.series[0].data[4].value = this.data.zxyhhtjy;
      });
    },

    //毕业生男女人数环形图
    drawGender2() {
      // 基于准备好的dom，初始化echarts实例
      let myChart5 = this.$echarts.init(document.getElementById("myChart5"));
      //准备数据
      // 绘制图表
      myChart5.setOption(this.option5);
    },
    //毕业生就业去向环形图
    drawEmployment2() {
      // 基于准备好的dom，初始化echarts实例
      let myChart6 = this.$echarts.init(document.getElementById("myChart6"));
      //准备数据

      // 绘制图表
      myChart6.setOption(this.option6);
    },
  },
};
</script>

<style scoped>
.title {
  line-height: 60px;
  font-weight: 400;
  font-size: 30px;
  padding: 20px 0;
  padding-top: 0;
  text-align: center;
}
.el-col {
  height: 500px;
}
</style>
